/**
 * Builds an Excel structured table name that is unique per worksheet in the workbook.
 * Trace outputs use a stable logical name from {@link TabularSheetPayload.tableName}; the host requires
 * workbook-unique names, so reusing the same base on another sheet would otherwise move the existing table.
 *
 * @param baseTableName — Logical name from formatters (e.g. `TraceAgreementsTable`).
 * @param worksheetId — {@link Excel.Worksheet.id} from the target sheet (stable for the sheet’s lifetime).
 */
export function buildUniqueTraceTableName(baseTableName: string, worksheetId: string): string {
    const idPart = worksheetId.replace(/[{}-]/g, '').slice(0, 16);
    const candidate = `${baseTableName}_${idPart}`;
    const maxLen = 250;
    if (candidate.length <= maxLen) {
        return candidate;
    }
    const keepBase = Math.max(1, maxLen - idPart.length - 1);
    return `${baseTableName.slice(0, keepBase)}_${idPart}`;
}
